import React from 'react';
import styled, { css } from 'styled-components';

import { baseColors, colorScheme } from '../../theme';

interface StatusMessageProps {
  variant?: 'info' | 'success' | 'warning' | 'danger';
  children: React.ReactNode;
  icon?: React.ReactNode;
  compact?: boolean;
}

const StatusMessageWrapper = styled.div<{ variant: string; compact: boolean }>`
  display: flex;
  align-items: center;
  border-radius: 6px;
  padding: ${({ compact }) => (compact ? '6px 12px' : '10px 16px')};
  margin-bottom: 12px;
  font-size: 14px;
  line-height: 1.4;

  ${({ variant }) => {
    switch (variant) {
      case 'success':
        return css`
          background-color: #e7f5ef;
          color: ${baseColors.green};
          border-left: 4px solid ${baseColors.green};
        `;
      case 'warning':
        return css`
          background-color: #fff4e5;
          color: ${colorScheme.text.base};
          border-left: 4px solid ${baseColors.orange};
        `;
      case 'danger':
        return css`
          background-color: #ffeded;
          color: ${colorScheme.text.base};
          border-left: 4px solid ${baseColors.red};
        `;
      case 'info':
      default:
        return css`
          background-color: #e5f3ff;
          color: ${colorScheme.text.base};
          border-left: 4px solid ${colorScheme.brand};
        `;
    }
  }}
`;

const IconContainer = styled.div`
  margin-right: 10px;
  display: flex;
  align-items: center;
`;

const ContentContainer = styled.div`
  flex: 1;
`;

export const StatusMessage: React.FC<StatusMessageProps> = ({ variant = 'info', children, icon, compact = false }) => (
  <StatusMessageWrapper variant={variant} compact={compact}>
    {icon && <IconContainer>{icon}</IconContainer>}
    <ContentContainer>{children}</ContentContainer>
  </StatusMessageWrapper>
);
